require('./formatted-size.js')

import formattedDate from './formatted-date'
import formattedTime from './formatted-time'
import fromNow from './date-from-now'

Vue.filter('formattedDate', formattedDate)
Vue.filter('formattedTime', formattedTime)
Vue.filter('fromNow', fromNow)